export const environment = {
  apiUrl: 'https://gryf.sk',
  production: true
};
